module.exports = __webpack_public_path__ + "static/img/p-8.3653cd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-8.png
// module id = 9adm
// module chunks = 0